import React, { useRef, useState } from 'react';
import { TextInput, View, Text, StyleSheet } from 'react-native';
import { colors, radii, spacing, typography } from '../config/theme';

const InputWrapper = ({
  value,
  onChangeText,
  placeholder,
  label,
  keyboardType = 'default',
  secureTextEntry = false,
  multiline = false,
  numberOfLines = 1,
  style,
  inputStyle,
  labelStyle,
  error,
  disabled = false,
  onFocus,
  onBlur,
  ...props
}) => {
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false);

  const onValueChange = (text) => {
    if (onChangeText) {
      onChangeText(text);
    }
  };

  return (
    <View style={[styles.container, style]}>
      {label && (
        <Text style={[styles.label, labelStyle]}>
          {label}
        </Text>
      )}
      <TextInput
        ref={inputRef}
        style={[
          styles.input,
          focused && styles.inputFocused,
          error && styles.inputError,
          disabled && styles.inputDisabled,
          multiline && styles.inputMultiline,
          inputStyle
        ]}
        value={value}
        onChangeText={onValueChange}
        onFocus={e => {
          setFocused(true);
          onFocus?.(e);
        }}
        onBlur={e => {
          setFocused(false);
          onBlur?.(e);
        }}
        placeholder={placeholder}
        placeholderTextColor={colors.textMuted}
        selectionColor={colors.secondary}
        keyboardType={keyboardType}
        secureTextEntry={secureTextEntry}
        multiline={multiline}
        numberOfLines={numberOfLines}
        editable={!disabled}
        {...props}
      />
      {error && (
        <Text style={styles.errorText}>
          {error}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: spacing.margin,
  },
  label: {
    ...typography.labelLg,
    color: colors.text,
    marginBottom: spacing.sm,
    marginLeft: spacing.xs,
  },
  input: {
    ...typography.bodyLg,
    height: 52,
    borderWidth: 1.5,
    borderColor: colors.border,
    borderRadius: radii.pill,
    paddingHorizontal: spacing.lg,
    paddingVertical: 0,
    backgroundColor: colors.surface,
    color: colors.text,
  },
  inputFocused: {
    borderColor: colors.primary,
  },
  inputError: {
    borderColor: colors.error,
    backgroundColor: colors.errorTint,
  },
  inputDisabled: {
    backgroundColor: colors.surfaceMuted,
    color: colors.textSubtle,
    borderColor: colors.border,
  },
  inputMultiline: {
    height: undefined,
    minHeight: 104,
    borderRadius: radii.card,
    paddingTop: spacing.md,
    paddingBottom: spacing.md,
    textAlignVertical: 'top',
  },
  errorText: {
    ...typography.bodySm,
    color: colors.error,
    marginTop: spacing.xs,
    marginLeft: spacing.lg,
  },
});

export default InputWrapper;
